import { CommonModule } from "@angular/common";
import { Component, Inject, Input, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import Swal from "sweetalert2";
import { CategoryService } from "../../../services/category.service";
import { Modal } from "bootstrap";
import { ModalService } from "../../../components/modal/service/modal.service";

@Component({
  selector: "app-category-form",
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: "./cashback-form.component.html",
  styleUrl: "./cashback-form.component.scss",
})
export class CashbackFormComponent implements OnInit {
  form: UntypedFormGroup;
  imagemCarregada = false;
  @Input() image?: string;

  constructor(
    private formBuilder: UntypedFormBuilder,
    @Inject(CategoryService) private categoryService: CategoryService,
    private modalService: ModalService
  ) {
    this.form = this.formBuilder.group({
      description: ["", Validators.required],
    });
  }

  async ngOnInit(): Promise<void> {}

  imagemCarregadaStatus() {
    this.imagemCarregada = true;
  }
}
